import React from 'react';
import PropTypes from 'prop-types';
import {
  List as StyledList,
  ListItem,
  ListItemPrimaryText,
  ListItemHeaderText,
  ListItemSecondaryText,
  TopDecorations,
  TopDecoration,
  ListItemContent,
  RightDecorations,
  RightDecoration,
  EmptyListItemText,
  ListItemAvatar,
  ListItemSecondaryHeaderText,
  ListItemTertiaryText,
} from './List.styled';

const List = ({ headerText, testId, children }) => (
  <StyledList data-testid={testId}>
    {headerText && (
      <ListItem>
        <ListItemHeaderText>{headerText}</ListItemHeaderText>
      </ListItem>
    )}
    {children}
  </StyledList>
);

List.propTypes = {
  headerText: PropTypes.string,
  children: PropTypes.node,
  testId: PropTypes.string,
};

List.defaultProps = {
  headerText: null,
  children: null,
  testId: null,
};

export {
  ListItem,
  ListItemContent,
  ListItemHeaderText,
  ListItemPrimaryText,
  ListItemSecondaryText,
  ListItemTertiaryText,
  TopDecorations,
  TopDecoration,
  RightDecorations,
  RightDecoration,
  EmptyListItemText,
  ListItemAvatar,
  ListItemSecondaryHeaderText,
};

export default List;
